import Link from 'next/link'

import Brand from '@/components/generals/brand'
import { NAV_LINKS, SERVICE_TYPES, siteConfig } from '@/constants/site'

export default function Footer() {
    return (
        <footer className='bg-foreground text-background'>
            <div className='mx-auto max-w-7xl px-4 pt-16 pb-10 sm:px-6 lg:px-8'>
                <div className='grid gap-12 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)]'>
                    <div className='max-w-sm'>
                        <Brand onDark />

                        <p className='mt-5 text-sm leading-relaxed text-background/60'>
                            {siteConfig.description}
                        </p>
                    </div>

                    <nav aria-label='Enlaces del pie de página'>
                        <p className='text-xs font-semibold uppercase tracking-[0.24em] text-champagne'>
                            Explora
                        </p>

                        <ul className='mt-5 space-y-3 text-sm'>
                            {NAV_LINKS.map(link => (
                                <li key={link.href}>
                                    <Link href={link.href} className='text-background/75 transition-colors hover:text-background'>
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <p className='text-xs font-semibold uppercase tracking-[0.24em] text-champagne'>
                            Servicios
                        </p>

                        <ul className='mt-5 space-y-3 text-sm text-background/75'>
                            {SERVICE_TYPES.map(service => (
                                <li key={service}>
                                    {service}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className='mt-14 flex flex-col gap-3 border-t border-background/10 pt-6 text-xs text-background/45 sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        © <span suppressHydrationWarning>{new Date().getFullYear()}</span> {siteConfig.name}. Todos los derechos reservados.
                    </p>

                    <Link href='/#reservar' className='transition-colors hover:text-background'>
                        Solicitar una reserva
                    </Link>
                </div>
            </div>
        </footer>
    )
}
